export default function Marquee() {
  const items = [
    "House Washing",
    "Driveways",
    "Soft-Wash Roofs",
    "Decks & Fences",
    "Commercial",
    "Gutters",
    "Trucks & Excavators",
    "Saint John · NB",
  ];
  const row = [...items, ...items];

  return (
    <section
      data-testid="marquee-section"
      className="border-y border-[#2A2A2A] bg-[#FFD600] text-black overflow-hidden"
    >
      <div className="flex animate-marquee whitespace-nowrap py-5">
        {row.map((t, i) => (
          <span
            key={i}
            className="font-display font-bold uppercase tracking-tight text-2xl md:text-3xl px-8 flex items-center gap-8"
          >
            {t}
            <span className="w-2 h-2 bg-black inline-block" />
          </span>
        ))}
      </div>
    </section>
  );
}
